import React from 'react';
import { isRichTextContent } from '../../../utils/resource-content';

interface ResourceDescriptionProps {
  content: string;
}

export const ResourceDescription: React.FC<ResourceDescriptionProps> = ({ content }) => {
  if (!content) {
    return null;
  }

  if (isRichTextContent(content)) {
    return (
      <div
        className="font-open-sans prose text-sm font-normal leading-[1.5] text-black md:pr-8"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  return (
    <p className="font-open-sans whitespace-pre-wrap text-sm font-normal leading-[1.5] text-black md:pr-8">{content}</p>
  );
};
